import { render, staticRenderFns } from "./VolunteerProfileFeedSection.vue?vue&type=template&id=69298da2&scoped=true"
import script from "./VolunteerProfileFeedSection.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileFeedSection.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileFeedSection.vue?vue&type=style&index=0&id=69298da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69298da2",
  null
  
)

export default component.exports